import { useRef } from "react";
import { Camera, PawPrint } from "lucide-react";

interface Props {
  photoPreview: string | null;
  handlePhotoChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  petName?: string;
  isEditing?: boolean;
}

const PetFormHeader = ({
  photoPreview,
  handlePhotoChange,
  petName = "",
  isEditing = false,
}: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="mb-6">
      <div className="flex flex-col items-center pt-8 pb-6 gradient-primary rounded-b-[2rem]">
        <div
          className="relative cursor-pointer group animate-spring-in"
          onClick={() => fileInputRef.current?.click()}
        >
          <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-primary-foreground/30 shadow-lg bg-muted">
            {photoPreview ? (
              <img
                src={photoPreview}
                alt="Foto do pet"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <PawPrint className="h-10 w-10 text-muted-foreground" />
              </div>
            )}
          </div>

          <div className="absolute bottom-0 right-0 gradient-coral rounded-full p-2.5 shadow-md border-2 border-card transition-transform group-hover:scale-110">
            <Camera className="h-4 w-4 text-secondary-foreground" />
          </div>

          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handlePhotoChange}
          />
        </div>

        <h2 className="mt-4 text-xl font-bold text-primary-foreground animate-fade-in-up">
          {petName || "Novo Pet"}
        </h2>

        <span className="text-sm text-primary-foreground/70 font-medium">
          {isEditing ? "Editando informações" : "Cadastrando pet"}
        </span>
      </div>
    </div>
  );
};

export default PetFormHeader;